export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#0A1628] text-white py-16">
      <div className="max-w-7xl mx-auto px-8">
        <div className="grid grid-cols-1 md:grid-cols-10 gap-12 mb-12">
          <div className="md:col-span-4">
            <h3 className="text-3xl font-light mb-4">ESVICOL LTDA</h3>
            <p className="text-gray-400 text-sm leading-relaxed mb-8">
              Your trusted partner in digital security. We provide enterprise-grade VPN solutions that protect your privacy and ensure unrestricted access to the internet.
            </p>
            <button
              onClick={() => scrollToSection('contact')}
              className="px-8 py-3 bg-white text-[#0A1628] text-sm font-semibold rounded-full hover:bg-gray-100 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Contact Us
              <i className="ri-arrow-right-line ml-2"></i>
            </button>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-sm font-semibold mb-6 tracking-wider">QUICK LINKS</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('features')}
                  className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer underline"
                >
                  Features
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('vpn-service')}
                  className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer underline"
                >
                  Security
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('privacy')}
                  className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer underline"
                >
                  Privacy Policy
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer underline"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-sm font-semibold mb-6 tracking-wider">CONTACT INFO</h4>
            <div className="space-y-4">
              <p className="text-gray-400 text-sm">
                <a href="mailto:information@esvicolltda.com" className="hover:text-white transition-colors">
                  information@esvicolltda.com
                </a>
              </p>
              <p className="text-gray-400 text-sm">
                <a href="tel:+14174288656" className="hover:text-white transition-colors">
                  +1 417-428-8656
                </a>
              </p>
              <div className="pt-4">
                <h5 className="text-sm font-semibold mb-2 tracking-wider">LOCATION</h5>
                <p className="text-gray-400 text-sm">
                  DIAGONAL 20 100 33<br />
                  BUCARAMANGA, 680005<br />
                  Colombia
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex gap-6">
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors text-sm underline">
                LinkedIn
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors text-sm underline">
                Twitter
              </a>
            </div>
            
            <p className="text-gray-400 text-sm">
              © 2025 ESVICOL LTDA. All rights reserved.
            </p>
            
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors text-sm underline">
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
